import React from "react";

const ICON_STYLE = {
  position: "absolute",
  bottom: "42px",
  right: "10px",
  fontWeight: "400",
  fontSize: "18px",
  color: "#777777",
  userSelect: "none",
  cursor: "pointer",
  padding: "2px",
  border: "1px solid #777777",
  borderRadius: "50%"
};

const ClearSignatureButton = ({ onClick }) => (
  <i
    className="material-icons-outlined"
    style={ICON_STYLE}
    styleName="clear"
    onClick={onClick}
  >
    clear
  </i>
);

export default ClearSignatureButton;
